module.exports = __webpack_public_path__ + "img/pattern_8.0512ce12.png";